import type { IconSvgObject } from './types';

const DoorLockIcon: IconSvgObject = [
  ["path", { d: "M3 22H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 22V5C4 3.34315 5.34315 2 7 2L17 2C18.6569 2 20 3.34315 20 5V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.9286 11.8079V9.89C13.9286 8.84618 13.0651 8 12 8C10.9349 8 10.0714 8.84618 10.0714 9.89V11.8079M12 17C10.3431 17 9 15.6837 9 14.06C9 12.4363 10.3431 11.12 12 11.12C13.6569 11.12 15 12.4363 15 14.06C15 15.6837 13.6569 17 12 17Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DoorLockIcon;
